import React from 'react';
import { Col } from 'react-bootstrap';
import ServicePlanContainer from '../../components/ServicePlanContainer/ServicePlanContainer';
import withStyles from 'isomorphic-style-loader/withStyles';
import cs from '../../components/commonStyle.css'

const UserServicePlan = (props) => {
    const { mode } = props;
    return (
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
            <ServicePlanContainer mode={mode} />
        </Col>
    )
}

export default withStyles(cs)(UserServicePlan);
